import { render, staticRenderFns } from "./ppd_refund_terminal_preferences.vue?vue&type=template&id=1a0a3ddb&"
import script from "./ppd_refund_terminal_preferences.vue?vue&type=script&lang=js&"
export * from "./ppd_refund_terminal_preferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports